import Calendar from './calendar/zh_TW';
import DatePicker from './date-picker/zh_TW';
import Pagination from './pagination/zh_TW';
import TimePicker from './time-picker/zh_TW';

export default {
  locale: 'zh-tw',
  Pagination,
  DatePicker,
  TimePicker,
  Calendar,
  Table: {
    filterTitle: 'ç¯©é¸å¨',
    filterConfirm: 'ç¢º å®',
    filterReset: 'é ç½®',
    selectAll: 'å¨é¨é¸å',
    selectInvert: 'ååé¸å',
  },
  Modal: {
    okText: 'ç¢º å®',
    cancelText: 'å æ¶',
    justOkText: 'OK',
  },
  Popconfirm: {
    okText: 'ç¢º å®',
    cancelText: 'å æ¶',
  },
  Transfer: {
    searchPlaceholder: 'æå°è³æ',
    itemUnit: 'é ç®',
    itemsUnit: 'é ç®',
  },
  Upload: {
    uploading: 'æ­£å¨ä¸å³...',
    removeFile: 'åªé¤æªæ¡',
    uploadError: 'ä¸å³å¤±æ',
    previewFile: 'æªæ¡é è¦½',
  },
  Empty: {
    description: 'ç¡æ­¤è³æ',
  },
};
